module.exports = __webpack_public_path__ + "static/media/right-icon-arrow.e912b681.svg";